<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Form from "../Form.vue";
import {corporateQuestions, privateQuestions} from "../../js/ClientDetailsQuestionSets";
import {mapStores, mapWritableState} from "pinia";
import {ClientStore} from "../../stores/ClientStore";
import {FormDataStore} from "../../stores/FormDataStore";

export default {
  name: "ClientDetailsQuestion",
  components: {
    Form,
    FontAwesomeIcon,
  },
  computed: {
    ...mapStores(ClientStore),
    ...mapWritableState(FormDataStore, ['formData']),
  },
  data: function () {
    return {
      privateQuestions: privateQuestions,
      corporateQuestions: corporateQuestions,
    };
  },
  methods: {
    setClientType(clientType) {
      this.formData.clientDetails.bookingType = clientType;

      if (clientType === "private") {
        this.formData.clientDetails.questions = this.privateQuestions;
      }

      if (clientType === "corporate") {
        this.formData.clientDetails.questions = this.corporateQuestions;
      }
    },
  },
}
</script>

<template>
  <div id="clientTypeQuestion">
    <div class="container mb-1">
      <div class="row">
        <div class="col-lg-6 p-4 client-option" @click="setClientType('private')" :class="{
          selected: formData.clientDetails.bookingType === 'private'
        }">
          <h4 class="optionHeading mb-1">I am the client</h4>
          <FontAwesomeIcon :icon="['fas', 'user']" size="lg" />
        </div>
        <div class="col-lg-6 p-4 client-option" @click="setClientType('corporate')" :class="{
          selected: formData.clientDetails.bookingType === 'corporate'
        }">
          <h4 class="optionHeading mb-1">I am booking on behalf of a client</h4>
          <FontAwesomeIcon :icon="['fas', 'city']" size="lg" />
        </div>
      </div>
      <div class="row mt-3">
        <Form />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>